// jQuery est déjà chargé par WordPress, on peut l'utiliser directement
const $ = window.jQuery;

import AOS from "aos";

// IMPORT DES COMPONENTS
import "./components/_mobile-menu";
import "./components/_header";
import "./components/_date-search";

// IMPORT DES PAGES
import { frontPage } from "./pages/front-page";

const initApp = () => {
    let bodyClassList = document.getElementsByTagName("body")[0].classList;
    switch (true) {
        case bodyClassList.contains("page-template-front-page"):
            frontPage.readyFn();
            
            break;
        default:
    }
};

// ----------------------------------- DOCUMENT READY -----------------------------------
// --------------------------------------------------------------------------------------
jQuery(function () {

    AOS.init();

    initApp();

});

// ----------------------------------- WINDOW LOAD --------------------------------------
// --------------------------------------------------------------------------------------
$(window).on("load", function () {

    // Smooth scroll sur les ancres
    $('a[href*="#"]:not([href="#"])').on('click', function (e) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 200 // Offset pour le header fixe
                }, 600); // Durée en ms
            }
        }
    });

});